export default "__VITE_ASSET__BFIIzWdb__"